const containsValidQuestion = (levels) => {
  // There is at least one valid quiz question for an article level with at least one valid option in the Checks For Understanding quiz.
  return levels?.some((level) =>
    level?.questions?.some((question) =>
      question?.options?.some((option) => option?.is_correct),
    ),
  );
};

/**
 * Returns an attachment CHECKS_FOR_UNDERSTANDING_QUIZ object.
 * This object should be the only attachment with assessment_type CHECKS_FOR_UNDERSTANDING_QUIZ
 * If none exists in the array of attachments, it will return undefined
 * @param {array} attachments
 * @returns {object}
 */
const getChecksForUnderstandingQuizAttachment = (attachments) => {
  if (!attachments) return;

  const checksForUnderstandingQuiz = attachments.filter((attachment) => {
    return attachment.data?.assessment_type === "CHECKS_FOR_UNDERSTANDING_QUIZ";
  });
  if (!containsValidQuestion(checksForUnderstandingQuiz?.[0]?.data?.levels))
    return;

  return checksForUnderstandingQuiz[0];
};

export default getChecksForUnderstandingQuizAttachment;
